import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from 'utils/logger';
import { EMPTY_VOUCHERS_BY_STATUS } from '../constants';
import { getAdminVouchers } from '../service';

export function useAdminVouchers() {
  const [vouchersByStatus, setVouchersByStatus] = useState(EMPTY_VOUCHERS_BY_STATUS);
  const [loading, setLoading] = useState(false);

  const fetchVouchers = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAdminVouchers();
      setVouchersByStatus(data);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch admin vouchers',
          error: err,
          code: 'ADMIN_VOUCHERS_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVouchers();
  }, [fetchVouchers]);

  return { vouchersByStatus, loading, refresh: fetchVouchers };
}
